
import { Component, Vue } from "vue-property-decorator";
import { MetaInfo } from "vue-meta";
// import Navbar from "@/components/Utility/Navbar.vue";
// import Footer from "@/components/Utility/Footer.vue";
@Component({
  components: {
    // Navbar,
    // Footer,
  }
})
export default class Privacy extends Vue {
  metaInfo(): MetaInfo {
    return {
      title: "隱私權政策｜師虎來了個人資料保護聲明",
      meta: [
        {
          vmid: "description",
          name: "description",
          content:
            "師虎來了重視您的個人資料保護，依中華民國個人資料保護法規範蒐集、處理及利用會員資料，詳見完整隱私權政策說明。",
        },
        {
          vmid: "og:title",
          property: "og:title",
          content: "隱私權政策｜師虎來了個人資料保護聲明",
        },
        {
          vmid: "og:description",
          property: "og:description",
          content:
            "師虎來了重視您的個人資料保護，依中華民國個人資料保護法規範蒐集、處理及利用會員資料，詳見完整隱私權政策說明。",
        },
      ],
      link: [
        {
          vmid: "canonical",
          rel: "canonical",
          href: "https://www.fdtigermaster.com/Privacy",
        },
      ],
    };
  }
}
